import { forwardRef } from 'react'

import s from './Checkbox.module.scss'

export interface CheckboxProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  labelText: string
  color?: 'secondary' | 'outlined'
  wrapperClassName?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function (
  { labelText, name, color, wrapperClassName, ...inputProps },
  ref
) {
  return (
    <label className={`${s.checkBox} ${wrapperClassName}`}>
      <input {...inputProps} type="checkbox" ref={ref} />
      <span className={`${s.styled} ${color && s[color]} `}></span>
      {labelText}
    </label>
  )
})
